import React from 'react';

import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import PatientSite from './pages/patientSite';
import ProviderSite from './pages/providerSite';

function App() {
  React.useEffect(() => {
    document.title = 'A Harm Reduction Guide to Anabolic Androgenic Steroids (Testosterone)';
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/patients" element={<PatientSite/>}/>
        <Route path="/providers" element={<ProviderSite/>}/>
      </Routes> 
    </HashRouter>
  );
}

export default App;
